import {
  Button, Card, CardContent, CardHeader, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Grid, IconButton, TextField, CircularProgress, Backdrop,
  FormControlLabel, Switch
} from '@material-ui/core';
import { red } from '@material-ui/core/colors';
import CropFreeIcon from '@material-ui/icons/CropFree';
import HistoryIcon from '@material-ui/icons/History';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect, useSelector } from 'react-redux';
import axios from 'src/utils/axios';
import { getKoordinat, GetLocation } from 'src/utils/Common';
import { loadBaslandiJob, saveBaslandiJob } from 'src/utils/storage/StartWorkOrder';
import BarkodPopup from '../../components/BarcodePopup';
import UrunTarihce from '../../components/ProductHistory';
import UrunSearch from '../../components/Selects/ProductSearch';
import RepeatOneIcon from '@material-ui/icons/RepeatOne';
import { getUser } from 'src/utils/Common';
import {
  getDefectRequest, getLabourRequest, getMaterialRequest, resetDefects, resetLabours, resetMaterials
} from '../../store/actions';

const useStyles = makeStyles((theme) => ({
  root: {},
  avatar: {
    backgroundColor: red[500],
  },
  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  policy: {
    display: 'flex',
    alignItems: 'center'
  },
  policyCheckbox: {
    marginLeft: '-14px'
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  submitButton: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
  content: {
    padding: 0,
    minHeight: 430,
  },
  text: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    marginLeft: '95%'
  },
}));

function Urun({
  className, ReceiptNo, readonly, tasks, getDefectRequest, getLabourRequest, getMaterialRequest, resetDefects, resetLabours, resetMaterials, DefectControlCheck, setTask
}) {
  const [open, setOpen] = React.useState(false);
  const [Uyari, setUyari] = React.useState('');
  const classes = useStyles();
  const SessionUser = getUser();
  const { t } = useTranslation('work_order');
  const [openBarkod, setOpenBarkod] = useState(false);
  const [UrunData, setUrunData] = useState({});
  const [clearBarkod, setClearBarkod] = useState(true);
  const [search, setSearch] = useState('');
  const today = new Date();
  const maxYil = today.getFullYear();
  // eslint-disable-next-line
  const [formValid, setFormValid] = useState(true);
  const [urunTarihceAc, seturunTarihceAc] = useState(false);
  const [SerialParam, setSerialParam] = React.useState('');
  const [loading, setLoading] = useState(false);
  const isOnline = useSelector((state) => state.status?.isOnline);
  const [formState, setFormState] = useState([
    {
      name: 'SerialNumber',
      min: 0,
      max: 9999999999,
      valid: true,
      errorMessage: t('error_serino')
    },
    {
      name: 'SerialNumberPK',
      min: 0,
      max: 25,
      valid: true,
      errorMessage: t('error_serinoPK')
    },
    {
      name: 'ProductionYear',
      min: 0,
      max: maxYil,
      valid: true,
      errorMessage: t('error_uyil').replace('@maxYil', maxYil)
    },
    {
      name: 'ProductionMonth',
      max: 12,
      min: 0,
      valid: true,
      errorMessage: t('error_udonem')
    }
  ]);
  const [barkod, setBarkod] = useState('');
  const [pendingBarcode, setPendingBarcode] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [confirmCallback, setConfirmCallback] = useState(null);
  const [confirmMessage, setConfirmMessage] = useState('');
  const [serialParsingLoading, setSerialParsingLoading] = useState(false);

  useEffect(() => {
    GetLocation();
    const storeData = readonly ? tasks.tasks.filter((d) => parseInt(d.ReceiptNo) === parseInt(ReceiptNo)) : loadBaslandiJob();
    if (storeData.length !== 0) {
      setUrunData(storeData[0]);
      setBarkod(storeData[0].Barcode);
    } else {
      setUrunData({});
    }
  }, [ReceiptNo, tasks.tasks, readonly]);



  const handleBarkodOpen = () => {
    if (!readonly) {
      setOpenBarkod(true);
    }
  };

  const handleBarkodClose = async (barkod) => {
    let job = loadBaslandiJob()[0];
    setOpenBarkod(false);
    if (readonly) return;
    if (barkod.length === undefined) return;

    if (barkod.startsWith('http://arce.lk')) {
      const firstQuestionMarkIndex = barkod.indexOf('?');
      const secondQuestionMarkIndex = barkod.indexOf('?', firstQuestionMarkIndex + 1);
      let extractedBarcode = '';
      let modelNumber = '';
      if (secondQuestionMarkIndex !== -1) {
        console.log(barkod)
        const rawExtractedBarcode = barkod.substring(secondQuestionMarkIndex + 1);
        modelNumber = barkod.substring(firstQuestionMarkIndex + 1, secondQuestionMarkIndex);
        console.log(rawExtractedBarcode)
        // rawExtractedBarcode'dan modelNumber'ı çıkar
        let barcodeWithoutModel = rawExtractedBarcode;
        if (rawExtractedBarcode.startsWith(modelNumber)) {
          barcodeWithoutModel = rawExtractedBarcode.substring(modelNumber.length);
          console.log(barcodeWithoutModel)
        }
        // Son iki karakter hariç kalan kısmı al
        extractedBarcode = barcodeWithoutModel.slice(0, -2);
        setSerialParam(extractedBarcode);

        // ModelCode farklıysa kullanıcıya sor
        if (job?.ModelCode && job.ModelCode !== modelNumber) {
          setConfirmMessage(
            `${t('Model Code is changing!')} (${job.ModelCode} → ${modelNumber})\n${t('Do you want to continue?')}`
          );
          setConfirmOpen(true);
          setConfirmCallback(() => (confirmed) => {
            setConfirmOpen(false);
            if (confirmed) {
              setLoading(true);
              setSearch(modelNumber);
              setPendingBarcode(extractedBarcode);
              setBarkod(modelNumber + extractedBarcode);
              setLoading(false);
              // loading kapanışı handleModelReady'de olacak
            }
            // Hayır derse hiçbir şey yapma
          });
          return;
        }
        setLoading(true);
        setSearch(modelNumber);
        setPendingBarcode(extractedBarcode);
        setBarkod(modelNumber + extractedBarcode);
        setLoading(false);
        return;
      }
    }

    setBarkod(barkod);


    const OperationDateParam = moment().utcOffset('+03:00').format('YYYY-MM-DD HH:mm:ss');
    const BarkodTarih = OperationDateParam;
    const BarkodEnlem = getKoordinat('Enlem');
    const BarkodBoylam = getKoordinat('Boylam');
    let txt_nitelik = 0;

    if (SessionUser.TenantId === 59) {
      var DummyProductYear = '1981';
      var DummySerialNr = '1';
      var DummyProductMonth = '1';
      job = {
        ...job,
        ProductionYear: DummyProductYear,
        ProductionMonth: DummyProductMonth,
        SerialNumber: barkod,
        AttributeId: parseInt(txt_nitelik),
        Barcode: barkod,
        BarcodeDate: BarkodTarih,
        BarcodeLatitude: BarkodEnlem,
        BarcodeLongitude: BarkodBoylam,
      };
      saveBaslandiJob(job);
      setUrunData(job);
      setClearBarkod(false);
      return;

    }



    if ([18, 20, 22].indexOf(barkod.length) === -1) { return; }

    const model_length = barkod.length === 18 ? 6 : 10;
    const txt_kul_model_kodu = barkod.substring(0, model_length);
    const remaining = barkod.substring(model_length, barkod.length);
    const txt_uyıl = `20${remaining.substring(0, 2)}`;
    const txt_serino = remaining.substring(2, 8);
    const txt_udonem = remaining.substring(8, 10);

    if (txt_kul_model_kodu.slice(-2) === 'RV' || txt_kul_model_kodu.slice(-2) === '99') {
      txt_nitelik = 1;
    }


    job = {
      ...job,
      ProductionYear: parseInt(txt_uyıl),
      ProductionMonth: parseInt(txt_udonem),
      SerialNumber: parseInt(txt_serino),
      AttributeId: parseInt(txt_nitelik),
      Barcode: barkod,
      BarcodeDate: BarkodTarih,
      BarcodeLatitude: BarkodEnlem,
      BarcodeLongitude: BarkodBoylam,
    };
    saveBaslandiJob(job);
    setUrunData(job);
    setClearBarkod(false);
    setSearch(txt_kul_model_kodu);
  };

  const fncUrunTarihceAc = () => {
    seturunTarihceAc(true);
  };

  const handleChange = (e) => {
    if (readonly) {
      return;
    }
    const { name } = e.target;
    const { value } = e.target;

    let tmpValid = true;
    for (let i = 0; i < formState.length; i++) {
      const obj = formState[i];
      if (obj.name === name && value) {
        if (value > obj.max || value <= obj.min) {
          setFormState([...formState.slice(0, i), { ...obj, valid: false }, ...formState.slice(i + 1)]);
        } else {
          setFormState([...formState.slice(0, i), { ...obj, valid: true }, ...formState.slice(i + 1)]);
        }
      }
      tmpValid = tmpValid && obj.valid;
    }
    setFormValid(tmpValid);
    if (e.target.type === 'checkbox') {
      const value = e.target.checked ? 1 : 0;
      let job = UrunData;
      job = { ...job, [name]: value };
      saveBaslandiJob(job);
      setUrunData(job);
    } else {
      const obj = formState.filter((f) => f.name === name)[0];
      if (parseInt(value) > obj.min && parseInt(value) <= obj.max) {
        let job = UrunData;
        job = { ...job, [name]: value };
        saveBaslandiJob(job);
        setUrunData(job);
      } else {
        let job = UrunData;
        job = { ...job, [name]: obj.min };
        saveBaslandiJob(job);
        setUrunData(job);
      }
    }
  };

  function changeSerialNumberForPk(e) {
    if (readonly) {
      return;
    }

    const { name } = e.target;
    const { value } = e.target;

    if (!(value.length > 25)) {
      let job = loadBaslandiJob()[0];
      job = { ...job, [name]: value };
      saveBaslandiJob(job);
      setUrunData(job);
    }

  }


  const setModel = (param) => {
    if (readonly) {
      return;
    }

    let job = loadBaslandiJob()[0];
    if (job.ModelCode !== param.KUL_MODEL_KODU) {
      if (clearBarkod) {
        setBarkod('');
        job = { ...job, Barcode: '' };
      } else {
        setClearBarkod(true);
      }
      setUyari(t('product_changed_message'));
      setOpen(true);
      resetLabours();
      resetDefects();
      resetMaterials();
      getDefectRequest(param.KUL_MODEL_KODU, 1);
      getMaterialRequest(param.KUL_MODEL_KODU, job.WarrantyTypeId, 1, UrunData.UYIL || 0, UrunData.UDONEM || 0, job.ReceiptNo);
      getLabourRequest(param.KUL_MODEL_KODU, job.WarrantyTypeId, 1, job.ReceiptNo);
      job = {
        ...job, HIZMETLER: [], ISCILIKLER: [], MALZEMELER: []
      };
    }
    job = {
      ...job,
      ModelCode: param.KUL_MODEL_KODU,
      Model: param.ACIKLAMA,
      HomeWhiz: param.HOMEWHIZ,
      BrandCode: param.MARKA_KODU,
      SerialNumber: null,
      ProductionMonth: null,
      ProductionYear: null,
      ProductId: param.MODEL_KODU
    };
    saveBaslandiJob(job);
    setUrunData(job);
  };

  function hasOnlyDigits(value) {
    return /^-?\d+$/.test(value);
  }

  function ControlSerialNrOldWay(Sku, Barcode, BarcodeParam, SerialNr, ProductMonth, ProductYear, job) {
    axios
      .get(`/ControlSerialNumber/${Sku}/${0}/${Barcode}`)
      .then(response => {
        if (response.data) {
          var serialNumberYear = calculateSerialNumberYear(response.data.ProductionYearRule, Barcode)
          var serialNumberMonth = calculateSerialNumberMonth(response.data.ProductionMonthRule, Barcode)
          var wantedSerialNumber = findOriginalSerialNumber(response.data.SerialNumberRule, Barcode)

          if (serialNumberYear != null && serialNumberMonth != null && wantedSerialNumber != null) {
            job = {
              ...job,
              Barcode: BarcodeParam,
              SerialNumber: wantedSerialNumber,
              ProductionMonth: serialNumberMonth,
              ProductionYear: serialNumberYear
            };

            saveBaslandiJob(job);
            setUrunData(job);
            return;
          }
        }
        else {
          if (Barcode.length === 10) {
            ProductYear = '20' + Barcode.substring(0, 2);
            SerialNr = Barcode.substring(2, 8);
            ProductMonth = Barcode.substring(8, 10);

            if (parseInt(ProductMonth) === 0 || parseInt(ProductMonth) > 12 || !hasOnlyDigits(ProductMonth)) {
              setUyari(Barcode + '-' + t('lblInvalidSerialNr'));
              setOpen(true);
              ProductYear = '';
              SerialNr = '';
              ProductMonth = '';
              job = {
                ...job,
                Barcode: '',
                SerialNumber: SerialNr,
                ProductionMonth: ProductMonth,
                ProductionYear: ProductYear
              };
              saveBaslandiJob(job);
              setUrunData(job);
              return;
            }

            if (
              ProductYear.length !== 4 ||
              parseInt(ProductYear) > parseInt(moment().format('yyyy')) ||
              !hasOnlyDigits(ProductYear)
            ) {
              setUyari(Barcode + '-' + t('lblInvalidSerialNr'));
              setOpen(true);
              ProductYear = '';
              SerialNr = '';
              ProductMonth = '';
              job = {
                ...job,
                Barcode: '',
                SerialNumber: SerialNr,
                ProductionMonth: ProductMonth,
                ProductionYear: ProductYear
              };
              saveBaslandiJob(job);
              setUrunData(job);
              return;
            }

            if (!hasOnlyDigits(SerialNr)) {
              setUyari(Barcode + '-' + t('lblInvalidSerialNr'));
              setOpen(true);
              ProductYear = '';
              SerialNr = '';
              ProductMonth = '';
              job = {
                ...job,
                Barcode: '',
                SerialNumber: SerialNr,
                ProductionMonth: ProductMonth,
                ProductionYear: ProductYear
              };
              saveBaslandiJob(job);
              setUrunData(job);
              return;
            }

            job = {
              ...job,
              Barcode: BarcodeParam,
              SerialNumber: SerialNr,
              ProductionMonth: ProductMonth,
              ProductionYear: ProductYear
            };
            saveBaslandiJob(job);
            setUrunData(job);
            return;
          }
          if (Barcode.length === 14 || Barcode.length === 18) {
            if (Barcode.length === 14) {
              ProductYear = '202' + Barcode.substring(5, 6);
              ProductMonth = Barcode.substring(6, 8);
              SerialNr = Barcode.substring(8, 13);
              job = {
                ...job,
                Barcode: BarcodeParam,
                SerialNumber: SerialNr,
                ProductionMonth: ProductMonth,
                ProductionYear: ProductYear
              };

              saveBaslandiJob(job);
              setUrunData(job);
            }
            if (Barcode.length === 18) {

              ProductYear = '20' + Barcode.substring(6, 8);
              ProductMonth = Barcode.substring(14, 16);
              SerialNr = Barcode.substring(9, 14);
              job = {
                ...job,
                Barcode: BarcodeParam,
                SerialNumber: SerialNr,
                ProductionMonth: ProductMonth,
                ProductionYear: ProductYear
              };

              saveBaslandiJob(job);
              setUrunData(job);
            }
          }

          setSerialParam(Barcode);
          if (SessionUser.TenantId !== 78) {
            if (
              ProductYear === '' ||
              ProductMonth === '' ||
              SerialNr === '' ||
              ProductYear === undefined ||
              ProductMonth === undefined ||
              SerialNr === undefined
            ) {
              setUyari(Barcode + '-' + t('lblInvalidSerialNr'));
              setOpen(true);
              ProductYear = '';
              SerialNr = '';
              ProductMonth = '';
              job = {
                ...job,
                Barcode: '',
                SerialNumber: SerialNr,
                ProductionMonth: ProductMonth,
                ProductionYear: ProductYear
              };
              saveBaslandiJob(job);
              setUrunData(job);
            }
            if (parseInt(ProductMonth) === 0 || parseInt(ProductMonth) > 12) {
              setUyari(Barcode + '-' + t('lblInvalidSerialNr'));
              setOpen(true);
              ProductYear = '';
              SerialNr = '';
              ProductMonth = '';
              job = {
                ...job,
                Barcode: '',
                SerialNumber: SerialNr,
                ProductionMonth: ProductMonth,
                ProductionYear: ProductYear
              };
              saveBaslandiJob(job);
              setUrunData(job);
            }
            if (
              ProductYear.length !== 4 ||
              parseInt(ProductYear) > parseInt(moment().format('yyyy'))
            ) {
              setUyari(Barcode + '-' + t('lblInvalidSerialNr'));
              setOpen(true);
              ProductYear = '';
              SerialNr = '';
              ProductMonth = '';
              job = {
                ...job,
                Barcode: '',
                SerialNumber: SerialNr,
                ProductionMonth: ProductMonth,
                ProductionYear: ProductYear
              };
              saveBaslandiJob(job);
              setUrunData(job);
              return;
            }
          }
        }
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
      });
  }

  const handleChangeBarcodeParse = Barcode => {

    setConfirmMessage('Serial Number parsing is in progress.');
    setSerialParsingLoading(true);
    let job = loadBaslandiJob()[0];
    var Sku = job?.ModelCode;
    var ProductYear = '';
    var ProductMonth = '';
    var SerialNr = '';
    var BarcodeParam = Sku + Barcode;
    var ProductId = job?.ProductId;
    setBarkod(BarcodeParam)

    if (Barcode === '9900000199' || SessionUser.TenantId === 59) {
      setUyari(Barcode + '-' + t('lblDummySerialNrWarning'));
      setOpen(true);
    }

    setLoading(true);
    axios
      .get(`/ParseSerialNumber/${ProductId}/${Barcode}`)
      .then(response => {
        if (response.data.Response == 1) {
          job = {
            ...job,
            Barcode: BarcodeParam,
            SerialNumber: response.data.SerialNr,
            ProductionMonth: response.data.MonthValue,
            ProductionYear: response.data.YearValue
          };

          saveBaslandiJob(job);
          setUrunData(job);
          setSerialParsingLoading(false);
          return;
        }
        else {
          setSerialParsingLoading(false);
          ControlSerialNrOldWay(Sku, Barcode, BarcodeParam, SerialNr, ProductMonth, ProductYear, job)
        }
      });


    if (
      SessionUser.TenantId === 9
      || SessionUser.TenantId === 37
      || SessionUser.TenantId === 51
      || SessionUser.TenantId === 56
      || SessionUser.TenantId === 78
    ) {
      return;
    }
  };

  function calculateSerialNumberYear(yearRule, serialNumber) {
    if (yearRule == null || yearRule == undefined) {
      return null
    }
    else if (yearRule.includes(',')) {
      var tempYearRule = yearRule.split(',')
      var result = parseInt('20' + serialNumber[parseInt(tempYearRule[0]) - 1] + serialNumber[parseInt(tempYearRule[1]) - 1])
      return result
    }
    //CONSTANT
    else if (yearRule == '0') {
      var result = 1981
      console.log('Year is: ' + result)
      return result
    }
    else {
      var year = parseInt(serialNumber[parseInt(yearRule) - 1])
      var currentYear = moment().format('yyyy')

      // Yıl Hesaplama için yılın son hanesini gelen yıl kuralının yılından çıkarıyorum
      // Eğer Kalan negatif ise mevcut yılın sonuna 10 ekleyip yıl kuralından çıkarıp onu da Bütün yıldan çıkarıyorum 
      // örnek: 8 geldi 2'den çıkarıyorum çünkü 2022, 2 - 8 = -6
      // -6 sıfırdan küçük olduğu için 2ye 10 ekliyorum ve 12 - 8 yapıyorum sonucum 4
      // bu elimde ki 4 ise 2022 den çıkarıyorum sonuç 2018

      if (parseInt(currentYear.substring(3)) - year < 0) {
        var result = parseInt(currentYear) - (parseInt(currentYear.substring(3)) + 10 - year)
        console.log('Year is: ' + result)
        return result
      }
      else {
        var result = parseInt(currentYear) - (parseInt(currentYear.substring(3)) - year)
        console.log('Year is: ' + result)
        return result
      }
    }
  }

  function calculateSerialNumberMonth(monthRule, serialNumber) {
    if (monthRule == null || monthRule == undefined) {
      return null
    }
    else if (monthRule.includes(',')) {
      var tempMonthRule = monthRule.split(',')
      var result = parseInt(serialNumber[parseInt(tempMonthRule[0]) - 1] + serialNumber[parseInt(tempMonthRule[1]) - 1])
      console.log('Month is: ' + result)
      if (parseInt(result) > 12) {
        setUyari(serialNumber + '-' + t('lblInvalidSerialNr'));
        setOpen(true);
        return null;
      }
      return result
    }
    else if (monthRule.length == 1 && monthRule != '0') {
      var tempResult = serialNumber[parseInt(monthRule) - 1]
      if (Number.isInteger(+tempResult)) {
        return tempResult
      }
      else if (tempResult == 'A') {
        return 10
      }
      else if (tempResult == 'B') {
        return 11
      }
      else if (tempResult == 'C') {
        return 12
      }
    }
    //CONSTANT
    else if (monthRule == '0') {
      var result = 1
      console.log('Month is: ' + result)
      return result
    }
    else {
      return null
    }
  }

  function findOriginalSerialNumber(serialNumberRule, serialNumber) {
    if (serialNumberRule == null || serialNumberRule == undefined) {
      return null
    }
    else if (serialNumberRule.includes(',')) {
      var tempSerialNumberRule = serialNumberRule.split(',')
      if (parseInt(tempSerialNumberRule[1]) - serialNumber.length === 1) {
        var result = serialNumber.substr(parseInt(parseInt(tempSerialNumberRule[0])) - 1, parseInt(parseInt(tempSerialNumberRule[1])) - 1)
        console.log('Serial Number is: ' + result)
        return result
      }
      else if (serialNumber.length !== parseInt(tempSerialNumberRule[1])) {
        setUyari(serialNumber + '-' + t('lblInvalidSerialNr'));
        setOpen(true);
        return null;
      }
      else {
        var result = serialNumber.substr(parseInt(parseInt(tempSerialNumberRule[0])) - 1, parseInt(parseInt(tempSerialNumberRule[1])) - 1)
        console.log('Serial Number is: ' + result)
        return result
      }
    }
    else {
      return null
    }
  }


  const handleClose = () => {
    setOpen(false);
  };

  // Model fetch tamamlandığında tetiklenecek fonksiyon
  const handleModelReady = (model) => {
    if (pendingBarcode) {
      // handleChangeBarcodeParse(pendingBarcode);
      setPendingBarcode(null);
      setLoading(false); // loading burada kapanır
    }
  };

  return (
    <Card className={clsx(classes.root, className)}>
      <CardHeader
        title={`${t('lblBarkod')}:${barkod}`}
        avatar={(
          <IconButton color="primary" aria-label="settings" onClick={handleBarkodOpen}>
            <CropFreeIcon />
          </IconButton>
        )}
      />
      <Divider />
      <CardContent className={classes.content}>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle id="alert-dialog-slide-title" color="primary">{t('Bilgilendirme')}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              {Uyari}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              {t('Tamam')}
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={confirmOpen}
          onClose={() => setConfirmOpen(false)}
          aria-labelledby="confirm-dialog-title"
          aria-describedby="confirm-dialog-description"
        >
          <DialogTitle id="confirm-dialog-title">{t('Bilgilendirme')}</DialogTitle>
          <DialogContent>
            <DialogContentText id="confirm-dialog-description">
              {confirmMessage}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => { setConfirmOpen(false); confirmCallback(false); }} color="primary">
              {t('No')}
            </Button>
            <Button onClick={() => { setConfirmOpen(false); confirmCallback(true); }} color="primary" autoFocus>
              {t('Yes')}
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={serialParsingLoading}
          onClose={() => setSerialParsingLoading(false)}
          aria-labelledby="confirm-dialog-title"
          aria-describedby="confirm-dialog-description"
        >
          <DialogTitle id="confirm-dialog-title">{t('Bilgilendirme')}</DialogTitle>
          <DialogContent>
            <DialogContentText id="confirm-dialog-description">
              {confirmMessage}
            </DialogContentText>
          </DialogContent>
        </Dialog>
        <Backdrop className={classes.backdrop} open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <form
          className={clsx(classes.root, className)}
        >
          <div className={classes.fields}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                {readonly
                  ? (
                    <TextField
                      label={t('input_urun')}
                      type="text"
                      value={(`${UrunData.ModelCode} - ${UrunData.Model}`) || ''}
                      fullWidth
                      required
                      InputLabelProps={{
                        shrink: true,
                      }}
                      disabled={readonly}
                      variant="outlined"
                      helperText={UrunData.Model}
                    />
                  )
                  : (
                    <UrunSearch
                      setModel={setModel}
                      value={{
                        KUL_MODEL_KODU: UrunData.ModelCode,
                        ACIKLAMA: UrunData.Model
                      } || ''}
                      searchParam={search}
                      disabled={!isOnline}
                      onModelReady={handleModelReady}
                    />
                  )}
              </Grid>
              <Grid item xs={6}>
                <TextField
                  label={t('input_uyil')}
                  name="ProductionYear"
                  type="number"
                  value={UrunData.ProductionYear || ''}
                  fullWidth
                  required
                  InputLabelProps={{
                    shrink: true,
                  }}
                  disabled
                  onChange={handleChange}
                  variant="outlined"
                  error={!formState.filter((n) => n.name === 'ProductionYear')[0].valid}
                  helperText={formState.filter((n) => n.name === 'ProductionYear')[0].valid ? '' : formState.filter((n) => n.name === 'ProductionYear')[0].errorMessage}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  label={t('input_udonem')}
                  name="ProductionMonth"
                  value={UrunData.ProductionMonth || ''}
                  type="number"
                  fullWidth
                  required
                  InputLabelProps={{
                    shrink: true,
                  }}
                  disabled
                  onChange={handleChange}
                  variant="outlined"
                  error={!formState.filter((n) => n.name === 'ProductionMonth')[0].valid}
                  helperText={formState.filter((n) => n.name === 'ProductionMonth')[0].valid ? '' : formState.filter((n) => n.name === 'ProductionMonth')[0].errorMessage}
                />
              </Grid>
              {
                SessionUser.TenantId === 59 || SessionUser.TenantId == 56 ?
                  <Grid item xs={6}>
                    <TextField
                      label={t('input_serino')}
                      name="SerialNumber"
                      value={UrunData.SerialNumber || ''}
                      fullWidth
                      required
                      disabled
                      onChange={changeSerialNumberForPk}
                      variant="outlined"
                      error={!formState.filter((n) => n.name === 'SerialNumberPK')[0].valid}
                      helperText={formState.filter((n) => n.name === 'SerialNumberPK')[0].valid ? '' : formState.filter((n) => n.name === 'SerialNumberPK')[0].errorMessage}
                    />
                  </Grid>
                  :
                  <Grid item xs={6}>
                    <TextField
                      label={t('input_serino')}
                      name="SerialNumber"
                      type="number"
                      value={UrunData.SerialNumber || ''}
                      fullWidth
                      required
                      InputLabelProps={{
                        shrink: true,
                      }}
                      disabled
                      onChange={handleChange}
                      variant="outlined"
                      error={!formState.filter((n) => n.name === 'SerialNumber')[0].valid}
                      helperText={formState.filter((n) => n.name === 'SerialNumber')[0].valid ? '' : formState.filter((n) => n.name === 'SerialNumber')[0].errorMessage}
                    />
                  </Grid>
              }

              <Grid item xs={4} style={{ margin: '6px' }}>
                <FormControlLabel
                  control={(
                    <Switch
                      color="primary"
                      readOnly
                      checked={UrunData.AttributeId === 1 || false}
                      onChange={handleChange}
                      disabled="disabled"
                      name="AttributeId"
                    />
                  )}
                  label="Rev"
                />
              </Grid>

              <Grid item xs={12}>
                <div >
                  <TextField
                    label={t('lblSerialNr')}
                    name="Barcode"
                    size="small"
                    value={SerialParam || ''}
                    fullWidth
                    onChange={e => setSerialParam(e.target.value)}
                    variant="outlined"
                    disabled={!isOnline}
                  />
                </div>
              </Grid>

              <Grid item xs={12}>
                <div className={classes.text}>
                  <Button
                    disableElevation
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={() => handleChangeBarcodeParse(SerialParam || '')}
                    disabled={!isOnline}
                  >
                    <RepeatOneIcon />
                  </Button>
                </div>
              </Grid>

              <div>
                <div className={classes.policy} />
              </div>


            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                {DefectControlCheck === 1 ? "" :
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={fncUrunTarihceAc}
                    className={classes.submitButton}
                    endIcon={<HistoryIcon>Gönder</HistoryIcon>}
                    disabled={!isOnline}
                  >
                    {t('Urune_Verilmis_Hizmetler')}
                  </Button>
                }
              </Grid>
            </Grid>
          </div>
        </form>
        <Divider />
        {
          (urunTarihceAc)
            ? <UrunTarihce UrunData={UrunData} />
            : <div />
        }
      </CardContent>


      <BarkodPopup
        onClose={handleBarkodClose}
        open={openBarkod}
        ScanTime={1000}
      />
    </Card>
  );
}

Urun.propTypes = {
  className: PropTypes.string,
};


export default connect(
  (state) => ({ tasks: state.tasks1 }),
  {
    resetLabours, resetDefects, resetMaterials, getDefectRequest, getLabourRequest, getMaterialRequest
  }
)(Urun);
